<template>
  <div class='container-fluid'>
    <div class='row'>
      <div class='col d-none d-sm-block'></div>
      <div id='stepBody' class='col-12 col-10-sm col-md-8' :class="stepBodyClasses" role="main">
          <stepheader-view/>
          <router-view/>
          <bottomnav-view/>
      </div>
      <div class='col d-none d-sm-block'></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isRedesignedPage() {
      return this.$route.meta.redesigned === true;
    },
    stepBodyClasses() {
      return [
        { 'col-lg-8': this.$route.meta.page !== 8 },
        ...(this.isRedesignedPage ? ['redesignedFont', 'redesignedPage' + this.$route.meta.page] : [])
      ];
    }
  }
};
</script>

<style>
.redesignedFont {
  font-family: "Fira Sans", sans-serif;
}
/* Style guide secondary text is #6F6F6F; the global rule uses the legacy #666666. */
.redesignedFont #stepHeader {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.redesignedFont #stepHeader > .row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
}
.redesignedFont #stepHeader > .row > [class*="col-"] {
  flex: none;
  max-width: 100%;
}
.redesignedFont .textStepProgress {
  color: #6F6F6F;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  margin: 0;
  padding-left: 0;
  text-align: left;
}
.redesignedFont .textStepTitle {
  font-size: 30px;
  font-weight: 400;
  line-height: 120%;
  color: #333333;
  margin: 0;
  padding-left: 0;
  text-align: left;
}
.redesignedFont .textInstructions {
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  color: #333333;
  margin: 0 !important;
  padding: 0;
}
.redesignedFont.redesignedPage8 .textInstructions {
  line-height: 18px;
}
@media (min-width: 768px) {
  .redesignedFont.redesignedPage8 #stepHeader,
  .redesignedFont.redesignedPage8 .textStepProgress,
  .redesignedFont.redesignedPage8 .textStepTitle,
  .redesignedFont.redesignedPage8 .textInstructions {
    align-items: center;
    text-align: center;
  }
}
@media (max-width: 767.98px) {
  .redesignedFont #stepHeader,
  .redesignedFont #stepHeader > .row {
    gap: 8px;
  }
  .redesignedFont .textStepTitle {
    font-size: 26px;
  }
  .redesignedFont .textInstructions,
  .redesignedFont.redesignedPage8 .textInstructions {
    font-size: 14px;
    line-height: 140%;
  }
}
.redesignedFont label {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.redesignedFont input,
.redesignedFont select {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  border-color: #606366 !important;
}
.redesignedFont input:not(.input-group input),
.redesignedFont select {
  border-radius: 12px !important;
}
.redesignedFont .input-group .input-group-text {
  border-top-left-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}
.redesignedFont .input-group input {
  border-top-right-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}
.redesignedFont .input-group-text {
  font-weight: 500;
  color: #333333;
  border-color: #606366 !important;
}
.redesignedFont ::placeholder {
  color: #6F6F6F !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.redesignedFont .btn-primary {
  font-weight: 700;
  font-size: 16px;
  color: #FFFFFF;
}
.redesignedFont .moreHelp img {
  width: 20px;
  height: 20px;
}
#stepBody.redesignedFont {
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 0 0 100%;
  max-width: 100%;
  padding: 28px 16px 40px;
}
#stepBody.redesignedFont.redesignedPage1 {
  gap: 28px;
  padding-top: 24px;
}
#stepBody.redesignedFont.redesignedPage8 {
  gap: 24px;
}
@media (min-width: 768px) {
  #stepBody.redesignedFont {
    -ms-flex: 0 0 calc(100% - 240px);
    flex: 0 0 calc(100% - 240px);
    max-width: 1200px;
    padding: 56px 0 80px;
  }
  #stepBody.redesignedFont.redesignedPage1 {
    padding-top: 56px;
  }
  #stepBody.redesignedFont.redesignedPage8 {
    gap: 32px;
  }
}
@media (min-width: 576px) and (max-width: 767.98px) {
  #stepBody.redesignedFont {
    padding-left: 32px;
    padding-right: 32px;
  }
}
@media (max-width: 767.98px) {
  #stepBody.redesignedFont {
    gap: 24px;
  }
  #stepBody.redesignedFont.redesignedPage1 {
    gap: 28px;
  }
}
</style>